
import { put, select, takeEvery, takeLatest, throttle } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { getDecisions, initializeSession, validateCaseId, getMatchingSessionIDs } from '../api'
import { push } from 'react-router-redux'

import * as actions from '../actionTypes'
import {DCP_SESSION_ALIVE_EXPIRATION} from '../constants'
import {setCookie} from '../utils'


export function* getDecisionsSaga(action) {
  try {
    const lang = action.payload.lang
    const availableDecisions = yield getDecisions(lang)
    yield put({
      type: actions.DECISIONS_REQUESTED_SUCCESS,
      payload: {[lang]: availableDecisions}
    })
  } catch(error) {
    yield put({type: actions.DECISIONS_REQUESTED_FAILURE, payload: {error}})
  }
}

export function* getMatchingSessionIDsSaga(action) {
  try {
    const response = yield getMatchingSessionIDs(action.payload.sessionId)
    yield put({type: actions.MATCHING_SESSION_IDS_REQUEST_SUCCESS, payload: {response}})
  } catch(error) {
    yield put({type: actions.MATCHING_SESSION_IDS_REQUEST_FAILED, payload: {error}})
  }
}

export function* initializeSessionSaga(action) {
  try {
    const {caseId, decisionId, lang} = action.payload
    const response = yield initializeSession(decisionId, caseId, lang)
    yield put({type: actions.SESSION_INITIALIZE_SUCCESS, payload: {
      caseId,
      lang,
      ...response
    }})
    setCookie('DcpSessionId', response.sessionId, DCP_SESSION_ALIVE_EXPIRATION)
    const counselingSession = yield select(state => state.counselingSession)
    // navigate to counseling session form
    yield put(push(counselingSession.pages[0].pathname))
  } catch(error) {
    const errorBody = yield error.response.json()
    error.errorText = errorBody.ERROR
    yield put({type: actions.SESSION_INITIALIZE_FAILURE, payload: {error}})
  }
}

export function* navigateSessionSaga(action) {
  // const page = action.payload.page
  // not exactly sure how this will pan out yet. Could use react-router-redux to push new location
  // yield put(push(`/session/${page}`))
}

export function* validateCaseIdSaga(action) {
  try {
    yield delay(500) // debounces with takeLatest
    const {caseId, decisionId} = action.payload
    yield validateCaseId(decisionId, caseId)
    yield put({type: actions.CASE_ID_VALIDATION_SUCCESS})
  } catch(error) {
    yield put({type: actions.CASE_ID_VALIDATION_FAILURE, payload: {error}})
  }
}

export const setupSagas = [
  takeEvery(actions.DECISIONS_REQUESTED, getDecisionsSaga),
  takeLatest(actions.SESSION_INITIALIZE_REQUESTED, initializeSessionSaga),
  takeEvery(actions.SESSION_NAVIGATION, navigateSessionSaga),
  throttle(750, actions.MATCHING_SESSION_IDS_REQUESTED, getMatchingSessionIDsSaga),
  takeLatest(actions.CASE_ID_VALIDATION_REQUESTED, validateCaseIdSaga)
]


// WEBPACK FOOTER //
// ./src/sagas/setup.js